import { render, staticRenderFns } from "./SummarySystem.vue?vue&type=template&id=1c6880a2"
import script from "./SummarySystem.vue?vue&type=script&lang=js"
export * from "./SummarySystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports